import React, {useEffect} from "react";
import './Header.scss';
import {Container, Nav, Navbar} from 'react-bootstrap';
import {NavLink} from 'react-router-dom';

function Header(){
    useEffect(() => {
        window.addEventListener("scroll", isSticky);
        return () => {
        window.removeEventListener("scroll", isSticky);
        };
    });

    const isSticky = (e: any) => {
        const header = document.querySelector(".header");
        const scrollTop = window.scrollY;
        scrollTop >= 50 ? header?.classList.add("header-sticky") : header?.classList.remove("header-sticky");
      };
    return(
        <div className="header">
            <Navbar sticky="top" bg="white" expand="lg">
                <Container>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <div className="logoView">
                        <NavLink className='navbar-brand' to='/'><img src="/images/logo.svg" alt="Edfora" /></NavLink>
                    </div>
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ms-auto">
                            <div className="logoSideMenuView d-flex d-lg-none">
                                <Navbar.Toggle aria-controls="basic-navbar-nav" className="menuClose" />
                                <NavLink className='navbar-brand' to='/'><img src="/images/logo.svg" alt="Edfora" /></NavLink>
                            </div>
                            <div className="headerMenuLinks">
                                <NavLink className={({ isActive }) => ["nav-link", isActive ? "active" : null].filter(Boolean).join(" ")} end to="/">Home</NavLink>
                                <NavLink className={({ isActive }) => ["nav-link", isActive ? "active" : null].filter(Boolean).join(" ")} end to="/aboutus">About Us</NavLink>
                                <NavLink className={({ isActive }) => ["nav-link", isActive ? "active" : null].filter(Boolean).join(" ")} end to="/products">Products</NavLink>
                                <NavLink className={({ isActive }) => ["nav-link", isActive ? "active" : null].filter(Boolean).join(" ")} end to="/careers">Careers</NavLink>
                                <NavLink className={({ isActive }) => ["nav-link", isActive ? "active" : null].filter(Boolean).join(" ")} end to="/contact">Contact</NavLink>
                            </div>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    )
}
export default Header;